<template>
    <div v-if="appType === constants.APP_TYPE_DEFAULT || (appType === constants.APP_TYPE_MULTIPLE && localCoregs.length)" v-show="localCoregs.length > hiddenCoregs.length" class="vanguard-coreg-container">
        <div v-for="(coreg, index) in visibleCoregs" :key="'coreg-' + index" class="form-group form-check">
            <label class="form-check-label">
                <input type="checkbox" class="form-check-input" :value="coreg.checked" :checked="coreg.checked"
                       @change="updateModel(coreg, $event.target.checked)"/>
                <span v-html="coreg.label"></span>
            </label>
        </div>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
import * as mutations from '../store/mutations';
import * as constants from '../constants';

export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    trackingCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      localCoregs: [], // { trackingCode: '...', label: '...', checked: false, hidden: false }
      appType: window.App.type,
      constants
    };
  },
  computed: {
    ...mapGetters([
      'isAspspPrefillEditedByUser',
      'isAspspEligible',
      'journeyConfig',
      'coregs'
    ]),
    visibleCoregs() {
      /**
       * We hide coregs that should be visible in case the customer is eligible to ASPSP to get the Palyance iframe as close as possible from the top of the page...
       */
      if (!this.journeyConfig.coregs || (this.isAspspEligible && !this.isAspspPrefillEditedByUser)) {
        return [];
      }

      return this.journeyConfig.coregs.filter(c => !c.hidden);
    },
    hiddenCoregs() {
      if (!this.journeyConfig.coregs) {
        return [];
      }

      return this.journeyConfig.coregs.filter(c => c.hidden);
    }
  },
  methods: {
    updateModel(coreg, checked) {
      coreg.checked = checked;
      this.$store.commit(mutations.SET_COREGS, this.localCoregs);
    },
    setCoregs() {
      if (this.journeyConfig.coregs && this.journeyConfig.coregs.length > 0) {
        this.localCoregs = this.journeyConfig.coregs;
        this.$store.commit(mutations.SET_COREGS, this.localCoregs);
      }
    }
  },
  created() {
    this.setCoregs();
  },
  watch: {
    journeyConfig() {
      this.setCoregs();
    }
  }
};
</script>



// WEBPACK FOOTER //
// coregs.vue?42c186be